import React from "react";
import { FiArrowLeft, FiBookOpen } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import vaisnavaPdf from "../../Assets/bengali.jpeg";

const GrihastaCourseBengali = () => {
  const navigate = useNavigate();

  const handleOpenForm = () => {
    window.location.href =
      "https://mayapurinstitute.org/course/255/Krsna_Conscious_Grihasthasrama_Course__Bengali_ONLINE";
  };

  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-start bg-gradient-to-br from-purple-100 via-pink-100 to-yellow-100 p-1 md:p-4">
      <div className="relative mt-4 w-[98%] rounded-xl bg-white p-2 shadow-2xl md:mt-10 md:w-[95%] md:p-4 lg:w-[90%]">
        {/* Header */}
        <div className="mb-2 flex items-center justify-between p-2 md:p-4">
          <button
            onClick={() => navigate(-1)}
            className="hidden items-center space-x-1 text-gray-700 transition-colors hover:text-gray-900 md:flex"
          >
            <FiArrowLeft size={20} />
            <span className="text-sm font-bold">Back</span>
          </button>

          <h2 className="w-full truncate text-center text-sm font-extrabold text-gray-800 md:w-auto md:text-right md:text-xl">
            Grihasta Ashrama Course Preview (Bengali)
          </h2>
        </div>

       
        <div className="overflow-hidden rounded-lg border border-gray-300 bg-gray-50">
          <img
            src={vaisnavaPdf}
            alt="Course Preview"
            className="block h-auto w-full"
          />
        </div>

        
        <div className="mt-4 flex justify-center pb-2">
          <button
            onClick={handleOpenForm}
            className="flex items-center gap-2 rounded-full bg-purple-600 px-8 py-3 font-bold text-white shadow-lg transition-all hover:bg-purple-700 active:scale-95"
          >
            <FiBookOpen />
            Click Here
          </button>
        </div>
      </div>
    </div>
  );
};

export default GrihastaCourseBengali;
